import Vue from 'vue';
import axios from 'axios';
import '../../../filters';
import moment from 'moment';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { DateTime } from "luxon"

export default {
  name: 'manageAssessment',
  components: {
    datetime: Datetime,
    DateTime,
    TreeSelect: require('../../../customcontrols/selectOfTree.vue').default,
    UploadImages: require('../uploadFiles/uploadFiles.vue').default,
    CameraWithoutDialogComp: require('@/components/camera/camera.vue').default,
  },
  props: {
    lookups: {
      type: Object,
      required: true
    },
    elementTypeId: {
      type: Number,
      required: true
    },
    entitySubId: {
      type: Number,
      default: -1,
    },
    elementId: {
      type: Number,
      required: true
    },
    assessmentDate: {
      type: String,
      required: true
    },
    isNewConditionAssessm: {
      type: Boolean,
      default: false
    },
    isReadOnly: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      imagesTabSync: 'capture',
      todayDate: null,
      assessment: null,
      type: 1,
      manualAutomated: 'Manual - Physical Inspection',

      conditionRatings: [],

      assessmentMethods: [],

      opertation: '',
      assessmentMethod: '',
      jobCardNo: '',
      conditionRating: '',
      photos: [],
      assessDate: '',
      captureImageDialog: true,
      uploadImageDialog: false,
      showUploadedImageList: false,
      activeStep: 'tab-assessment',
      imagesTab: false,
      assessmentTab: false,
    }
  },
  watch: {
    isReadOnly: function (value) {
      if (value) {
        this.uploadImageActions();
      }
    },
    assessment: function (value) {
      value.displayDate = moment(value.date).format('DD/MM/YYYY HH:mm');
    },
  },
  created() {
    //this.$root.$on('save-picture-assessment', (item) => this.savePicture(item.image));
    this.today = moment(new Date()).format();
    this.$material.locale.dateFormat = 'yyyy-MM-dd';
    this.getConditionRating();

    if (this.isReadOnly) {
      this.uploadImageActions();
    }    
  },
  methods: {
    tabChanged(id) {
      //console.log("adijsoisadiusdiasfdi", id)
      if (id == 'tab-images' && this.entitySubId < 0) {
        //save assessment actions
        if (this.saveAssessmentChecks() == false) { 
          this.$alertMsg(this.$t('assets.SaveAssesmFirst'), 3);
          this.activeStep = 'tab-assessment';
        }
        else
          this.saveAssessment(true);
      }
    },
    uploadImageActions(action) {
      this.imagesTabSync = action;

      if (action == 'capture') {
        this.captureImageDialog = true;
        this.uploadImageDialog = false;
        this.showUploadedImageList = false;
      }
      else if (action == 'upload') {
        this.captureImageDialog = false;
        this.uploadImageDialog = true;
        this.showUploadedImageList = false;
      }
      else {
        this.getPhotos();
        this.captureImageDialog = false;
        this.uploadImageDialog = false;
        this.showUploadedImageList = true;
      }
    },
    savePicture(item) {
      let image = item.image;

      let parameters = [{ 'elementId': this.elementId.toString(), 'entitySubId': this.entitySubId.toString(), 'base64': image }];

      axios.post('/ConditionAssessment/SaveImages', parameters)
        .then(response => {
          if (response.status == 200) {
            this.$alertMsg(this.$t('common.uploadedSuccessfully'), 2);
            //console.log('ProcessPhotos response', response);

            //this.$emit('uploadImage', response.data.ids);
          }
        })
        .catch(error => {
          this.$alertMsg(error.response.data);
        });
    },
    getConditionRating() {

      const parameters = {
        value: this.elementTypeId,
      };

      axios.post('/Om/GetElementTypeConditions', parameters)
        .then(response => {
          if (response.status == 200) {
            response.data.items = response.data.items.slice(1);
            this.conditionRatings = this.fillLookUpList(response.data.items, 'conditionId', 'name');
            this.getAssessment();
          }
        }).catch(error => {
          this.$alertMsg(error);
        });
    },
    getAssessment() {
      if (this.isNewConditionAssessm) {
        let prof = this.$store.getters.getUserProfile;
        this.manualAutomated = 'Manual - Physical Inspection';
        this.assessment = {
          type: this.lookups.types.length == 0 ? null : this.lookups.types.filter(a => a.selected).length == 0 ? null : this.lookups.types.filter(a => a.selected)[0].id,
          elementTypeId: this.elementTypeId,
          elementId: this.elementId,
          date: this.assessmentDate,
          jobcardId: null,
          conditionId: null,
          inspectorName: prof && prof.name ? prof.name : '',
          inspectionMeasureId: this.lookups.requiredMeasures.length == 0 ? null : this.lookups.requiredMeasures.filter(a => a.selected).length == 0 ? null : this.lookups.requiredMeasures.filter(a => a.selected)[0].id,
          inspectionMethodId: this.lookups.inspectionMethods.length == 0 ? null : this.lookups.inspectionMethods.filter(a => a.selected).length == 0 ? null : this.lookups.inspectionMethods.filter(a => a.selected)[0].id,
          inspectionPurposeId: this.lookups.purposes.length == 0 ? null : this.lookups.purposes.filter(a => a.selected).length == 0 ? null : this.lookups.purposes.filter(a => a.selected)[0].id,
          inspectionCommentId: null,
          urgencyId: null,
          evaluationId: null,
          projectId: null,
          importanceId: null,
          costOfRepairs: 0.00,
          extendedLife: 0,
          comment: '',
          recommendedMeasures: []
        };
      }
      else {
        this.$store.state.notifier.asyncBlock(
          axios.get('/ConditionAssessment/Get', { params: { elementTypeId: this.elementTypeId, elementId: this.elementId, dt: this.assessmentDate } }),
          response => {
            if (response.status == 200) {
              this.assessment = response.data;
              this.manualAutomated = response.data.jobcardId == null ? 'Manual - Physical Inspection' : response.data.jobcardId == 0 ? 'Manual - Physical Inspection' : 'Automated - Maintenance Records';
              this.getPhotos();
            }
          },
          error => {
            this.$alertMsg(error.response.data);
          }
        );
      }
    },
    fillLookUpList(list, idField, labelField) {
      var selectList = [];

      var item = {};

      for (var i = 0; i < list.length; i++) {
        item = list[i];

        item['id'] = item[idField];
        if (idField != 'id')
          delete item[idField];

        item['label'] = item[labelField];
        if (labelField != 'label')
          delete item[labelField];

        selectList.push(item);
      }

      return selectList;
    },
    fillList(list) {
      var selectList = [];

      for (var i = 0; i < list.length; i++) {
        selectList.push({
          id: list[i].value,
          label: list[i].text,
          group: list[i].group,
          selected: list[i].selected,
        });
      }

      return selectList;
    },
    onItemSelected(group, rowIndex, item) {
      for (var i = 0; i < this.elementProperties.properties['' + group + ''][rowIndex].value.length; i++) {
        this.elementProperties.properties['' + group + ''][rowIndex].value[i].selected = false;

        if (this.elementProperties.properties['' + group + ''][rowIndex].value[i].value == item.id)
          this.elementProperties.properties['' + group + ''][rowIndex].value[i].selected = true;
      }
    },
    displayError(msg, scrollTo) {
      this.$alertMsg(msg, 3);
      this.$scrollToElement(scrollTo);
    },
    saveAssessmentChecks() {
      if (this.assessment.type == null || this.assessment.type < 0) {
        this.displayError(this.$t('assets.typeError'), 'type');
        return false;
      }

      if(this.assessment.type != 0){
        if (moment(this.assessment.date).isAfter(moment(new Date))) {
          this.displayError(this.$t('assets.wrongDate'), 'date')
          return false;
        }

        if (this.assessment.inspectorName == null || this.assessment.inspectorName == '') {
          this.displayError(this.$t('assets.inspectorNameError'), 'inspector');
          return false;
        }

        if (this.assessment.conditionId == null || this.assessment.conditionId < 0) {
          this.displayError(this.$t('assets.conditionError'), 'condition');
          return false;
        }
      }

      let flag = true;

      this.assessment.recommendedMeasures.forEach(a => {
        if (flag && a.years < 0) {
          this.displayError(this.$t('assets.yearsError'), 'measures');
          flag = false;
        }

        if (flag && !a.measureId) {
          this.displayError(this.$t('assets.requiredMessuresError'), 'measures');
          flag = false;
        }
      })

      return flag;
    },
    saveAssessment(keepWidndowAlive = false) {
      if (!this.saveAssessmentChecks())
        return;

      this.assessment.projectId = 11;

      for (var i = 0; i < this.assessment.recommendedMeasures.length; i++) {
        this.assessment.recommendedMeasures[i].conditionDate = this.assessment.date.replace(' ', 'T');
        this.assessment.recommendedMeasures[i].years = Number(this.assessment.recommendedMeasures[i].years);
        this.assessment.recommendedMeasures[i].cost = Number(this.assessment.recommendedMeasures[i].cost);
      }

      if (this.assessment.evaluationId == null || this.assessment.evaluationId == '')
        this.assessment.evaluationId = -1;

      this.$store.state.notifier.asyncBlock(
        axios.post('/ConditionAssessment/Save', this.assessment),
        response => {
          if (response.status == 200) {
            this.$alertMsg(this.$t('assets.assessmentHasBeenSavedSuccessfully'), 2);
            this.assessment = response.data;

            if (!keepWidndowAlive)
              this.closeDialog();
            else
              this.$emit('refreshManageAssessment', response.data, false);
          }
        },
        error => {
          this.$alertMsg(error.response.data);
        },
        this.$t('common.saving')
      );
    },
    closeDialog() {
      this.$emit('closeDialog', 'refresh');

    },
    getPhotos() {
      let parameters = { params: { elementId: this.elementId, entitySubId: this.entitySubId } };

      axios.get('/ConditionAssessment/GetImages', parameters )
        .then(response => {
          if (response.status == 200) {
            this.photos = response.data;
          }
        })
        .catch(error => {
          this.$alertMsg(error.response.data);
        });
    },
    downloadPhoto(id, fileName) {
      axios.get('/ConditionAssessment/DownloadImage?imageId=' + id, { responseType: 'blob' })
        .then(response => {
          if (response.status == 200) {
            var fileURL = window.URL.createObjectURL(new Blob([response.data]));
            var fileLink = document.createElement('a');

            fileLink.href = fileURL;
            fileLink.setAttribute('download', fileName);
            document.body.appendChild(fileLink);

            fileLink.click();
          }
        })
        .catch(error => {
          this.$alertMsg(error.response.data);
        });
    },
    uploadImage(ids) {
      for (var i = 0; i < ids.length; i++) {
        this.photos.push({
          entityId: this.elementId,
          entitySubId: this.entitySubId,
          entityType: 0,
          fileName: 'photo_' + moment(new Date()).format('YYYY-MM-DDThh:mm:ss').toString(),
          imageDate: moment(new Date()).format('YYYY-MM-DDThh:mm:ss'),
          imageId: ids[i]
        });
      }
    },
    addRequiredMeasure() {
      this.assessment.recommendedMeasures.push(
        {
          id: 0,
          elementTypeId: this.elementTypeId,
          elementId: this.elementId,
          measureId: null,
          description: '',
          years: 0,
          cost: 0
        }
      );
    },
    deleteMeasure(index) {
      if (this.assessment.recommendedMeasures[index].id == 0)
        this.assessment.recommendedMeasures.splice(index, 1);
      else {
        axios.post('/ConditionAssessment/DeleteMeasure', { Value: this.assessment.recommendedMeasures[index].id })
          .then(response => {
            if (response.status == 200) {
              this.assessment.recommendedMeasures.splice(index, 1);
            }
          }).catch(error => {
            this.$alertMsg(error);
          });
      }
    },
  },
}
